import React, { useEffect, useState } from "react";
import { Global } from '../../../Variables/Global';
import { GetCurrencies } from '../../../api/HttpService'
import { FiRefreshCcw, FiRefreshCw, FiPlus } from 'react-icons/fi';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from "react-select";
import DataTable, { Alignment } from "react-data-table-component";
import { BsAlignCenter } from 'react-icons/bs';
import dateFormat from 'dateformat';
import { getDecodedToken } from '../../../utils/utils';


const ShipmentLiveTracking = () => {
    const pId = useParams();
    const [permissions, setPermissions] = useState([]);
    useEffect(() => {
        document.title = "Live Tracking"
    }, []);

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="page-title-box">
                    <h4>Live Tracking</h4>
                    <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                        <li className="breadcrumb-item active">Live Tracking</li>
                    </ol>
                </div>
            </div>
            <iframe
                src={`https://shipsgo.com/iframe/where-is-my-container/${pId.ContainerCode}`}
                id="IframeShipsgoLiveMap"
                height="550px"
                allowFullScreen
                width="100%"
            />
        </div>
    );
};
export default ShipmentLiveTracking;